import axios from 'axios';
import store from '@/store';
import router from '@/router'
import Vue from "vue";

Vue.use(router);

class ApiClient {
    constructor() {
        this.axiosBase = axios.create({
            baseURL: process.env.VUE_APP_API_BASE_URL,
        });
    }

    async initToken() {
        const result = this.axiosBase.get(
            '/posts',
        ).then(
            (res) => {
                store.dispatch('setToken', res.data.data._code);
                return res;
            },
        ).catch(
            (err) => {
                return err;
            },
        );
        return result;
    }

    async get(endPoint, successCallback = null, failCallback = null, user = false) {
        document.querySelector('#connections').style.display = 'block';

        let header = {
            headers: {
                contentType: 'application/json',
            }
        };
        if (store.getters.token !== '') {
            header = {
                headers: {
                    token: store.getters.token,
                    contentType: 'application/json',
                }
            };
        }
        const result = this.axiosBase.get(
            endPoint,
            header,
        ).then(
            (res) => {
                document.querySelector('#connections').style.display = 'none';
                if (!this._resultParse(res)) {
                    return ;
                }
                if (successCallback) {
                    successCallback(res);
                }
                return res.data.data;
            },
        ).catch(
            (err) => {
                document.querySelector('#connections').style.display = 'none';
                if (user) {
                    router.push('/');
                } else {
                    router.push('/admin');
                }
                if (failCallback) {
                    failCallback(err);
                }
                alert('タイムアウトによりログアウトしました');
                return err;
            },
        );
        return result;
    }

    post(endPoint, postParam = null, addHeader = true, user = false) {
        document.querySelector('#connections').style.display = 'block';
        store.dispatch('setErrors', '')
        let header = {};
        if (addHeader) {
            header = {
                headers: {
                    token: store.getters.token,
                    contentType: 'application/json',
                }
            };
        }

        const params = new URLSearchParams();
        let json = '';
        if (postParam) {
            json = JSON.stringify(postParam);
        } else if (store.getters.getPostParam) {
            json = JSON.stringify(store.getters.getPostParam);
        }
        params.append('data', json);
        const result = this.axiosBase.post(
            endPoint,
            params,
            header,
        ).then(
            (res) => {
                document.querySelector('#connections').style.display = 'none';
                if (!this._resultParse(res)) {
                    return ;
                }
                store.dispatch('setErrors', res.data.data.errors);
                if (res.data.data.errors && Object.keys(res.data.data.errors).length != 0) {
                    window.scroll({
                        top: 0,
                    });
                }
                return res.data.data;
            },
        ).catch(
            (err) => {
                if (user) {
                    router.push('/');
                } else {
                    router.push('/admin');
                }
                document.querySelector('#connections').style.display = 'none';
                alert('タイムアウトによりログアウトしました');
                return err;
            },
        );
        return result;
    }

    _resultParse(res) {
        if(res.data.data.state === 444) {
            // router.push('/');
            return false;
        }
        if(res.data.data.state === 500) {
            // router.push('/');
            alert('サーバーエラーが発生しました');
            return false;
        }
        store.dispatch('setToken', res.data.data._code);
        return true;
    }
}

export default ApiClient;
